<template>
  <v-container />
</template>

<script>
import apiCalls from '@/helpers/apiCall'
import api from '@/helpers/api'
import parseJwt from '@/helpers/parseJwt'
import { loadLanguage } from '@/plugins/i18n'
import { mapMutations, mapActions, mapState } from 'vuex'

export default {
  name: 'Login',

  props: {
    token: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      isAuthenticating: false
    }
  },

  created() {
    this.loggedin()
  },

  methods: {
    ...mapActions('notification', ['setSnackbar']),
    ...mapMutations('checkout', ['setTotalItemsCheckout']),
    ...mapActions('checkout', ['getCheckout']),
    ...mapActions('account', [
      'getAccountDetails',
      'getCurrencyInfo',
      'synchronizeVisibilityTrucks'
    ]),
    ...mapMutations('account', ['setBootingStatus']),
    ...mapState('locale', ['locales']),
    ...mapState('account', ['synchronizedTruckVisibilityLoading']),

    async loggedin() {
      // Prevent multiple simultaneous authentication attempts
      if (this.isAuthenticating) {
        return
      }

      try {
        this.isAuthenticating = true
        this.setBootingStatus(true)
        await apiCalls
          .authentication(api.AccountSSOUserInfo, {
            token: this.token
          })
          .then(async res => {
            const userToken = res.headers['user-token']
            this.$store.commit('account/setUserToken', userToken)
            localStorage.setItem('userToken', userToken)

            const payload = parseJwt(userToken)
            let userLanguage = payload.Language

            if (!this.locales().includes(userLanguage)) {
              userLanguage = 'en-gb'
            }

            if (userLanguage !== this.$i18n.locale) {
              await loadLanguage(userLanguage)
            }

            // Requests for initial bootup
            this.setSnackBarCallback(true)
            await this.synchronizeVisibilityTrucks()
            // Carregar accountDetails primeiro - necessário para verificar CddCheck
            await this.getAccountDetails()
            await this.$store.dispatch('products/getServicesProducts', true)
            await this.getCurrencyInfo()
            await this.getCheckout()
            await this.setTotalItemsCheckout()

            // Usar dados do store em vez de chamada duplicada
            const accountDetails = this.$store.state.account.accountInformation
            if (!accountDetails || !accountDetails.CddCheck) {
              this.$router.push({
                name: 'payment_information'
              })
            } else {
              this.$router.push({
                name: 'home'
              })
            }

            this.setSnackBarCallback(false)
            this.setBootingStatus(false)
            this.isAuthenticating = false
          })
      } catch (error) {
        console.error('Authentication error:', error)
        let errorMessage = 'Authentication failed. Please try again.'

        if (error.response) {
          // Server responded with error status
          errorMessage = `Server error: ${error.response.status} - ${error.response.statusText}`
        } else if (error.request) {
          // Request was made but no response received (CORS, network issues)
          errorMessage =
            'Network error. Please check your connection or contact support.'
        } else {
          // Something else happened
          errorMessage = error.message || 'An unexpected error occurred.'
        }

        this.setSnackbar({
          showing: true,
          type: 'error',
          text: errorMessage
        })
        this.setBootingStatus(false)
      } finally {
        this.isAuthenticating = false
      }
    },
    async setSnackBarCallback(showing) {
      this.setSnackbar({
        showing: !!showing,
        type: '',
        text: 'We are loading your vehicles...',
        timeout: showing ? -1 : 5000
      })
    }
  }
}
</script>
